import { css, type Theme } from "@emotion/react";

import { baseStyles } from "@styles";

export const ModalFooter = css`
  padding-top: 1rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: auto;
`;

export const FooterShadow = (theme: Theme) => css`
  padding: 2rem;
  ${baseStyles.modalFooter(theme)};
`;
